
<div>
  @if(report) {
    <div class="main-container">
      <div class="header-title">
        <wm-common-text
          [data]="{
            text: report.name,
            fontSize: '16px',
            fontWeight: '500',
            color: '#343741'
          }"
        ></wm-common-text>

        <wm-common-text
          [data]="{
            text: report.description,
            fontSize: '14px',
            fontWeight: '400'
          }"
        ></wm-common-text>
      </div>

      <wm-custom-report-filter-input
        [report]="report"
        [form]="form"
        (filtersChanged)="this.filters = $event"
        [staffFilterBuilder]="true"
      ></wm-custom-report-filter-input>

      <div class="execute-btn">
        <wm-common-button
          [data]="{
            text: 'EXECUTE',
            disabled: executeDisabled,
          }"
          (click)="executeReport()"
        ></wm-common-button>
        <wm-common-text
          [data]="{
            text: 'Note: Depending on the criteria you choose above, the report may take several minutes to complete.',
            fontSize: '14px',
            fontWeight: '400',
            color: 'red'
          }"
        ></wm-common-text>
      </div>
    </div>
    <app-custom-report-request-list-janus #customReportList [customReportId]="reportId" [userId]="userId"></app-custom-report-request-list-janus>
  }
</div>
